export default function mapClassifier(tables, holder) {
    return Object.fromEntries(tables.map(m => ([m, function (state) { return state[holder][m] }])))
}